import { StoryEventObject } from "../domain/StoryEventObject";
import { JsonUtil } from "../../cutil/JsonUtil";
import { StudioProjectAttributesV3Node } from "../../project/domain/StudioProjectAttributesV3Node";
import { StoryNodeType } from "../domain/StoryNodeType";
import { StoryNodeUtil } from "../domain/StoryNodeUtil";
import { StoryLineOptionsUtil } from "../domain/StoryLineOptionsUtil";
import { StoryTransformerUtil } from "./StoryTransformerUtil";
import { StudioProjectAttributesV3NodeData } from "../../project/domain/StudioProjectAttributesV3NodeData";
import { StoryNodeState } from "../domain/StoryNodeState";
import { StoryNodeDisplayType } from "../domain/StoryNodeDisplayType";
import { tryBlock } from "../../cutil/LangUtil";
import { BlueprintModel } from "../model/BlueprintModel";
export class StoryTransformer {
    static transform(originalData, storyObject, story) {
        const node = StoryEventObject.asNode(storyObject);
        if (node) {
            if (node.children.length !== 0 && node.options.type === StoryNodeType.CUSTOMGROUP) {
                return StoryTransformer.transformGroupNode(node, story);
            }
            return StoryTransformer.transformNode(originalData, node, story);
        }
        const edge = StoryEventObject.asEdge(storyObject);
        if (edge) {
            return StoryTransformer.transformEdge(originalData, edge);
        }
        return originalData;
    }
    static transformGroupNode(storyNode, story) {
        const groupNodeProjectModel = StoryTransformerUtil.createEmptyGroupUiData();
        const nodeProjectModel = JsonUtil.toModelFromType(StudioProjectAttributesV3Node, groupNodeProjectModel);
        if (!nodeProjectModel)
            return [groupNodeProjectModel];
        nodeProjectModel.type = StoryNodeType.CUSTOMGROUP;
        nodeProjectModel.id = storyNode.id;
        let dataModel = nodeProjectModel?.data;
        if (dataModel) {
            const nodeData = dataModel;
            const childIds = storyNode.children.map(n => n.options.id);
            nodeData.childNode = childIds;
            nodeProjectModel.data = nodeData;
        }
        const jsonStr = JsonUtil.stringify(nodeProjectModel);
        if (!jsonStr)
            return [groupNodeProjectModel];
        const newData = JSON.parse(jsonStr);
        const returnArr = [newData];
        storyNode.children.forEach(child => {
            const childObject = StoryTransformer.transformNode(StoryTransformerUtil.createEmptyNodeUiData(), child, story, storyNode.id, "parent");
            returnArr.push(childObject);
        });
        return returnArr;
    }
    static transformNode(originalData, storyNode, story, parentNode, extent) {
        const nodeProjectModel = JsonUtil.toModelFromType(StudioProjectAttributesV3Node, originalData);
        if (!nodeProjectModel)
            return originalData;
        nodeProjectModel.id = storyNode.options.id;
        nodeProjectModel.type = StoryNodeType.CUSTOMNODE;
        nodeProjectModel.parentNode = parentNode;
        nodeProjectModel.extent = extent;
        let dataModel = nodeProjectModel?.data || new StudioProjectAttributesV3NodeData();
        let nodeData = dataModel;
        const displayType = StoryTransformerUtil.createDisplayType(storyNode, story);
        nodeData.displayType = displayType;
        if (storyNode.state === StoryNodeState.ERROR) {
            nodeData.errorText = storyNode.content;
            nodeData.textAreaValue = "";
        }
        else if (displayType == StoryNodeDisplayType.TEXT || displayType == StoryNodeDisplayType.JSON) {
            const content = tryBlock(() => JSON.parse(storyNode.content));
            content.data && content.data.displayType
                ? (nodeData = { ...nodeData, ...content.data })
                : (nodeData.textAreaValue = storyNode.content);
        }
        else if (displayType == StoryNodeDisplayType.BLUEPRINT) {
            const storyBlueprintModel = storyNode.parseContent(BlueprintModel);
            nodeData = { ...nodeData, blueprintMessage: storyBlueprintModel?.message };
            nodeData.textAreaValue = storyBlueprintModel?.data;
        }
        else {
            nodeData.errorText = "";
            nodeData.textAreaValue = StoryTransformerUtil.createTextAreaValue(storyNode, story, displayType);
        }
        if (displayType == StoryNodeDisplayType.STOCKINFO || displayType == StoryNodeDisplayType.HTMLTEMPLATE) {
            if (storyNode.state == StoryNodeState.LOADING || storyNode.state == StoryNodeState.RECEIVING) {
                nodeData.stockLoading = true;
            }
            else {
                nodeData.stockLoading = false;
            }
        }
        nodeData.showFeedback = storyNode.state == StoryNodeState.COMPLETED ? true : false;
        nodeData.parentNodeId = parentNode;
        nodeData.showStopGenerateBtn =
            storyNode.state == StoryNodeState.RECEIVING || storyNode.state == StoryNodeState.LOADING;
        nodeData = StoryTransformer.setIndexRef(nodeData, story);
        nodeProjectModel.data = nodeData;
        const jsonStr = JsonUtil.stringify(nodeProjectModel);
        if (!jsonStr)
            return originalData;
        const newData = JSON.parse(jsonStr);
        return newData;
    }
    static setIndexRef(dataModel, story) {
        const maxNodeIndex = StoryNodeUtil.maxIdNumber(story);
        const nodeIndexRef = dataModel.nodeIndexRef;
        if (nodeIndexRef) {
            if (nodeIndexRef.current == undefined || nodeIndexRef.current < maxNodeIndex + 1) {
                nodeIndexRef.current = maxNodeIndex + 1;
                dataModel.nodeIndexRef = nodeIndexRef;
            }
        }
        const maxLineIndex = StoryLineOptionsUtil.maxIdNumber(story);
        const edgeIndexRef = dataModel.edgeIndexRef;
        if (edgeIndexRef) {
            if (edgeIndexRef.current == undefined || edgeIndexRef.current < maxLineIndex + 1) {
                edgeIndexRef.current = maxLineIndex + 1;
                dataModel.edgeIndexRef = edgeIndexRef;
            }
        }
        return dataModel;
    }
    static transformEdge(originalData, storyNode) {
        return originalData;
    }
}
